define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi",
	"csi/table/Widget",
	"csi/xml",
	"csi/xml/Query"
], function(declare,lang,csi,Table,xml,Query) {

	return declare(Table, {
		activeMaterialType: csi.EMPTY_URL,

		getPrintProperties: function() {
			// summary: return object containing properties from view necessary to recreate it for printing that are not custom view options
			var params = this.inherited(arguments);
			params.activeMaterialType = this.activeMaterialType;
			return params;
		},

		onAccessAggregateFrom: function(/*Context*/ctx, /*Action*/action) {
			// summary: do not allow action when type is not selected
			return xml.isValidURL(this.activeMaterialType);
		},

		_createQueryLevel: function(/*Object*/params, /*Boolean*/bRoot) {
			// summary: add filter if specified in page location
			var	ql = this.inherited(arguments);

			if (ql.bMain && xml.isValidURL(this.activeMaterialType)) {
				ql.serverQuery = new Query().RefAttr("ProductType", xml.OP_EQUALS, this.activeMaterialType);
			}

			return ql;
		}
	});
});